var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 13 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#888",
  d: "M7.425 7.65v5.213H4.963V7.65H0V5.213h4.963V0h2.462v5.213H12.4V7.65z"
})));
export default SvgPlus;